<template>
  <v-card>
    <v-card-title>
      <div>{{ title }}</div>
      <v-spacer></v-spacer>
      <div>
        <v-select
          v-model="localCoinId"
          class="select-wrap"
          flat
          single-line
          dense
          outlined
          item-text="label"
          item-value="value"
          :items="coinList"
          :menu-props="{ offsetY: true }"
        ></v-select>
      </div>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="data"
      :hide-default-footer="true"
      :no-data-text="$t('common.noRecords')"
      mobile-breakpoint="0"
    >
      <template v-slot:item.created="{ item }">
        {{ setTimeZone(item.created) }}
      </template>
      <template v-slot:item.lastUpdateTime="{ item }">
        {{ setTimeZone(item.lastUpdateTime) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn @click="$emit('showGaModal', item)" class="btn-red-outline mr-2" depressed small>
          {{ $t('actions.delete') }}
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: {
    coinId: {
      type: [String, Number],
      default: ''
    },
    coinList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    localCoinId: {
      get() {
        return this.coinId;
      },
      set(val) {
        this.$emit('update:coinId', val);
      }
    }
  },
  data() {
    return {
      search: '',
      headers: [
        { text: this.$t('labels.finance.coin'), value: 'coinName', sortable: false },
        { text: this.$t('labels.remarks'), value: 'name', sortable: false },
        { text: this.$t('labels.finance.withdrawalAddr'), value: 'addr', sortable: false },
        { text: this.$t('labels.finance.memo'), value: 'memo', sortable: false },
        { text: this.$t('labels.cdate'), value: 'created', sortable: false },
        { text: this.$t('labels.mdate'), value: 'lastUpdateTime', sortable: false },
        { text: this.$t('labels.actions'), value: 'action', sortable: false }
      ]
    };
  }
};
</script>
<style lang="stylus" scoped>
.v-select.select-wrap::v-deep {
  .v-input__control {
    .v-input__slot {
      margin-bottom: 0;
      min-height: 35px;
      .v-select__selections {
        .v-select__selection {
          font-size: 0.85rem;
          max-width: 100%;
        }
        input {
          display: none;
        }
      }
      .v-input__append-inner {
        align-self: unset;
        margin-top: 0px;
        i {
          margin-top: 0px;
        }
      }
    }
    .v-text-field__details {
      display: none;
    }
  }
}
</style>
